<template>
<layout-base :title="$t('FINISH.THANKS')">
  <div slot="content" class="bk-reg-finish-text">
    <p>{{$t('FINISH.DESCRIPTION')}}</p>
    <p>{{$t('FINISH.HOW_CONTINUE')}}</p>
    <div class="bk-reg-apps">
      <span>{{$t('FINISH.USE_AS_APP')}}</span>
      <div class="bk-reg-apps__container">
        <a @click="fireAndroidEvent()"
           :href="androidUrl"
           target="_blank"
           class="bk-reg-apps__container__android-badge"
        >
          <img class="bk-reg-apps__container__icon"
               src="https://registration.bildkontakte.de/assets/badge_android.png"
               :alt="$t('FINISH.ANDROID_ALT_TAG')"
          >
        </a>
        <a @click="fireIosEvent()"
           :href="iosUrl"
           target="_blank"
           class="bk-reg-apps__container__ios-badge"
        >
          <img class="bk-reg-apps__container__icon"
               src="https://registration.bildkontakte.de/assets/badge_ios.svg"
               :alt="$t('FINISH.IOS_ALT_TAG')"
          >
        </a>
      </div>
    </div>
  </div>
  <template slot="buttons">
  <p class="bk-reg-finish-text">{{$t('FINISH.USE_IN_BROWSER')}}</p>
  <bk-button @click="openWebpage">{{$t('GLOBAL.CONTINUE')}}</bk-button>
  </template>
</layout-base>
</template>
<script>
import LayoutBase from './LayoutBase'
import { mapState } from 'vuex'
import BkButton from '../../../common/BkButton'

export default {
  name: 'StepFinished',
  components: { LayoutBase, BkButton },
  computed: {
    ...mapState(['promoter', 'legacyLogin']),
    /**
     * gets the app store route for ios
     * @returns {string}
     */
    iosUrl () {
      return this.getStoreUrl('iosCampaignTracking')
    },
    /**
     * get the play store route for android
     * @returns {string}
     */
    androidUrl () {
      return this.getStoreUrl('androidCampaignTracking')
    }
  },
  mounted () {
  },
  methods: {
    /**
     * open the bildkontakte website.
     * if the property legacyLogin is true its navigate to the old verison
     *  if the property legacyLogin is true its navigate to the new verison
     */
    openWebpage () {
      this.fireTrackEvent('DoubleOptin', 'WebseiteVerwenden')

      if (this.legacyLogin) {
        this.requestLegacyLogin()
          .then((data) => {
            window.location.href = data.link
          })
          .catch(error => this.$sentry.captureException(error))
      } else {
        this.setCookie()
        window.location.href = `${process.env.RL_URL}`
      }
    },
    setCookie () {
      const domain = window.location.hostname
        .split('.')
        .reverse()
        .slice(0, 2)
        .reverse()
        .join('.')
      document.cookie = `bk.transferToken=${this.accessToken}; max-age=1800; domain=${domain}; same-site=lax; path=/`
    },
    /**
     * return the calculated url for the app stores
     * @param platformUri uri for android or ios
     * @returns {string}
     */
    getStoreUrl (platformUri) {
      let url = `https://www.bildkontakte.de/app/tracking/${platformUri}.php`
      if (!this.promoter.isEmpty()) url = `${url}?gew=${this.promoter}`
      return url
    },
    fireAndroidEvent () {
      this.fireTrackEvent('DoubleOptin', 'AndroidHolen')
    },
    fireIosEvent () {
      this.fireTrackEvent('DoubleOptin', 'IOSHolen')
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "../../../scss/colors";

  .bk-reg-finish-text {
    //text-align: center;
    color: rgba($on-surface, .50);
  }

  .bk-reg-apps {
    margin-top: 16px;
    position: relative;

    &__container {
      display: flex;
      justify-content: space-between;
      margin: 16px 0;


      &__icon {
        width: 130px;
        height: 40px;
      }

      &ios-badge {
        margin-right: 20px;
      }
    }
  }
</style>
